import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const rule = yup
  .object({
    name: yup.string().required(),
  })

export const FleetMateRuleResolver = yupResolver(rule);
